interface HireMeProps {
  experienceStartYear: number;
}

function HireMe({ experienceStartYear }: HireMeProps) {
  const years = new Date().getFullYear() - experienceStartYear;

  return (
    <div id="fh5co-started" className="fh5co-bg-dark">
      <div className="overlay"></div>
      <div className="container">
        <div className="row animate-box">
          <div className="col-md-8 col-md-offset-2 text-center fh5co-heading">
            <h2>Hire Me!</h2>
            <p>Unlocking {years} years of invaluable experience, I stand ready to propel your organization to new heights. With a mastery of Java, JavaScript, Node.js, React, and PostgreSQL, I bring a wealth of knowledge to fuel your projects. Embracing agile methodologies, I'll guide your team towards success, employing cutting-edge technologies like AWS, Docker, and Kubernetes. Let's embark on a transformative journey together.</p>
            <p><a href="#fh5co-consult" className="btn btn-default btn-lg">Contact Me</a></p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HireMe;
